import { AxiosError } from "axios";

export function getSimpleErrorMessage(error: unknown): string {
  const axiosError = error as AxiosError<{
    Result?: Record<string, string[]>;
    message?: string;
    error?: string;
  }>;

  if (axiosError.response?.data?.Result) {
    const firstErrorField = Object.values(axiosError.response.data.Result)[0];
    if (firstErrorField?.length) return firstErrorField[0];
  }

  return (
    axiosError.response?.data?.message ||
    axiosError.response?.data?.error ||
    axiosError.message ||
    "Não foi possível completar a operação"
  );
}
